// extracted by mini-css-extract-plugin
export var boxItems = "_a6-1";
export var button = "_a6-5";
export var filterGroupBox = "_a6-0";
export var icon = "_a6-2";
export var iconSecondary = "_a6-4";
export var iconWrapper = "_a6-3";